import React from 'react';
import { useMachines } from '../context/MachineContext';
import styles from './ToastContainer.module.css';

export default function ToastContainer() {
  const { toasts } = useMachines();
  if (!toasts.length) return null;

  return (
    <div className={styles.container}>
      {toasts.map(t => (
        <div key={t.id} className={`${styles.toast} ${styles[t.type]}`}>
          <span className={styles.icon}>
            {t.type === 'success' ? '✅' : t.type === 'error' ? '❌' : 'ℹ️'}
          </span>
          <span className={styles.msg}>{t.message}</span>
        </div>
      ))}
    </div>
  );
}
